import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { CustomComponentProps } from './index';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProblemImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  
  /* iOSの長押しメニューを無効化 */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
`;

const HiddenHotspot = styled.div`
  position: absolute;
  bottom: 15%;
  right: 25%;
  width: 80px;
  height: 80px;
  cursor: pointer;
  /* デバッグ用: 半透明の赤色で表示 */
  /* background: rgba(255, 0, 0, 0.3); */
  
  /* iOSの長押しメニューを無効化 */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
`;

const HintPopup = styled.div<{ show: boolean }>`
  position: absolute;
  bottom: 30%;
  right: 20%;
  padding: 20px 30px;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  border-radius: 10px;
  border: 3px solid #ffd700;
  opacity: ${props => props.show ? 1 : 0};
  transform: ${props => props.show ? 'scale(1)' : 'scale(0.8)'};
  transition: all 0.3s ease;
  pointer-events: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  
  &::before {
    content: '';
    position: absolute;
    bottom: -10px;
    right: 30px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffd700;
  }
`;

// プログレスバーは削除（コメントアウト）
// const ProgressBar = styled.div<{ progress: number }>`
//   ...
// `;

export const KanzumeLastProblemComponent: React.FC<CustomComponentProps> = ({ imageUrls }) => {
  const [showHint, setShowHint] = useState(false);
  const holdTimerRef = useRef<NodeJS.Timeout | null>(null);
  
  const handleMouseDown = () => {
    // 3秒後にヒントを表示（押した瞬間のリアクションは無し）
    holdTimerRef.current = setTimeout(() => {
      setShowHint(true);
      // 5秒後に自動的に非表示
      setTimeout(() => {
        setShowHint(false);
      }, 5000);
    }, 3000);
  };
  
  const handleMouseUp = () => {
    if (holdTimerRef.current) {
      clearTimeout(holdTimerRef.current);
    }
  };
  
  useEffect(() => {
    return () => {
      if (holdTimerRef.current) {
        clearTimeout(holdTimerRef.current);
      }
    };
  }, []);
  
  if (!imageUrls || imageUrls.length === 0) {
    return <div>画像が設定されていません</div>;
  }
  
  return (
    <Container>
      <ProblemImage src={imageUrls[0]} alt="問題画像" />
      <HiddenHotspot
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={(e) => {
          e.preventDefault(); // iOSのデフォルト動作を無効化
          handleMouseDown();
        }}
        onTouchEnd={(e) => {
          e.preventDefault();
          handleMouseUp();
        }}
        onContextMenu={(e) => e.preventDefault()} // 右クリックメニューも無効化
      />
      <HintPopup show={showHint}>
        答えは「きらぼし」
      </HintPopup>
    </Container>
  );
};